module.exports = __webpack_public_path__ + "img/2.62c8d5bc.png";